import styled from 'styled-components';

export const SelectFilterContainer = styled.div`
  & > * {
    width: 100%;
  }
`;
